import ajaxRequest from './ajax'
import qs from "qs"

export const load_my_events = () => {
    return ajaxRequest.get("event/load_my_events");
}

export const load_current_active_event = () => {
    return ajaxRequest.get("event/load_current_active_event");
}

export const load_current_active_eventv2 = () => {
  return ajaxRequest.get("event/load_current_active_eventv2")
}

export const get_event_by_attendee = params => {
    return ajaxRequest.post("event/get_event_by_attendee?" + qs.stringify(params));
}

export const get_session_by_speaker = params => {
    return ajaxRequest.post("event/get_session_by_speaker?" + qs.stringify(params));
}

export const get_event_basic_info = params => {
    return ajaxRequest.get("event/get_event_basic_info?" + qs.stringify(params));
}

export const get_event_user_status = params => {
    return ajaxRequest.get("event/get_event_user_status?" + qs.stringify(params));
}

export const request_join_event_direct = params => {
    return ajaxRequest.post("event/request_join_event", params);
}

export const get_event_role = params => {
    return ajaxRequest.get("event/get_event_role?" + qs.stringify(params))
}

// 获取频道列表
export const get_channel_list_by_event_broadcaster = params => {
    return ajaxRequest.get("event/get_channel_list_by_event_broadcaster?" + qs.stringify(params))
}

// 判断审批状态
export const get_my_registration_status  = params => {
  return ajaxRequest.post("event/get_my_registration_status")
}
// 判断当前用户是否为活动的管理员
export const check_is_event_owner  = params => {
  return ajaxRequest.post("event/check_is_event_owner?"+qs.stringify(params))
}

export const get_session_by_event_id = params => {
  return ajaxRequest.get("session/get_session_by_event_id?"+qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/event.js